export default __webpack_public_path__ + "static/media/Sage's Girdle of the Crumbling Tower.0e3406ca.jpg";